"use client";
import React, { useState } from 'react';
import Image from 'next/image';
import "../../scss/_about-us.scss";
import heroImage from '../../../public/icons/hero.png';
import energySectorImage from '../../../public/icons/energySector.png';
import bannerabout from '../../../public/icons/banneraboutus.jpg';
import founderone from '../../../public/icons/founderone.png';
import foundertwo from '../../../public/icons/foundertwo.png';
import Accessibility from './../../../public/icons/Accessibility.svg';
import Expertise from './../../../public/icons/Expertise.svg';
import Integrity from './../../../public/icons/Integrity.svg';
import Sustainability from './../../../public/icons/Sustainability.svg';
import Community from './../../../public/icons/Community.svg';
import Objectivity from './../../../public/icons/Objectivity.svg';

export default function AboutUs() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "What topics does Invest in Energy cover?",
      answer: "We cover a wide range of topics including investment strategies, market analysis, energy economics, policy updates, and practical investment guides."
    },
    {
      question: "Who can benefit from your platform?",
      answer: "Our platform is designed for both beginners and experienced investors looking to expand their knowledge in oil and gas investments."
    },
    {
      question: "Are your courses beginner-friendly?",
      answer: "Yes, we provide beginner-friendly guides and structured learning paths to help newcomers understand the fundamentals of energy investing."
    },
    {
      question: "Do you offer certifications?",
      answer: "Currently, we focus on providing educational content and resources. Certification programs may be available in the future."
    },
    {
      question: "How frequently is your market content updated?",
      answer: "We update our market insights and content regularly to ensure you have access to the latest information and trends in the energy sector."
    }
  ];

  const coreValues = [
    {
      title: "Accessibility",
      description: "Clear, practical insights for everyone, from industry veterans to first-time investors.",
      icon: (
        <Image src={Accessibility} alt='Accessibility' />

      )
    },
    {
      title: "Expertise",
      description: "Backed by a network of finance and energy professionals who put your interests first.",
      icon: (
        <Image src={Expertise} alt='Accessibility' />
      )
    },
    {
      title: "Integrity",
      description: "Every insight is supported by transparent data and trusted research.",
      icon: (
        <Image src={Integrity} alt='Accessibility' />
      )
    },
    {
      title: "Sustainability",
      description: "Promoting responsible investments that consider long-term impact and future generations.",
      icon: (
        <Image src={Sustainability} alt='Accessibility' />
      )
    },
    {
      title: "Community-Focus",
      description: "Driven by what matters most to you and the communities we serve.",
      icon: (
        <Image src={Community} alt='Accessibility' />
      )
    },
    {
      title: "Objectivity",
      description: "Unbiased, data-driven guidance. No agenda, just education.",
      icon: (
        <Image src={Objectivity} alt='Accessibility' />
      )
    }
  ];

  return (
    <div className="about-us-page-au">
      {/* Hero Section */}
      <section className="hero-section-au">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="hero-content-au">
                <span className="hero-label-au">ABOUT US</span>
                <h1 className="hero-title-au">Shaping Smarter Oil & Gas Investors of Tomorrow</h1>
                <p className="hero-description-au">
                  Invest in Energy is building the future of energy investment. By decentralizing knowledge and providing accessible oil and gas investment resources, we are giving professionals and beginners the confidence to chart their own investment journey.
                </p>
              </div>
              <div className="hero-image-wrapper-au">
                <Image 
                  src={bannerabout} 
                  alt="Oil and Gas Facility" 
                  className="hero-image-au"
                  fill
                  priority
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fueling Knowledge Section */}
      <section className="fueling-section-au">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="fueling-image-wrapper-au">
                <Image 
                  src={energySectorImage} 
                  alt="Industrial Pipes" 
                  className="fueling-image-au"
                  fill
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="fueling-content-au">
                <h2 className="fueling-title-au">Fueling Knowledge. Powering Investment.</h2>
                <p className="fueling-text-au">
                  Our aim is simple: bridge the energy knowledge gap for investors. We are action-oriented, bringing together cutting-edge investment tools, expert insights, and market updates to make oil and gas investment accessible to all.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission and Vision Section */}
      <section className="mission-vision-section-au">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="mission-box-au">
                <h3 className="mission-title-au">Our Mission</h3>
                <p className="mission-text-au">
                  Democratize oil and gas investment by delivering accurate, accessible, and industry-relevant education through a growing community of investors.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="vision-box-au">
                <h3 className="vision-title-au">Our Vision</h3>
                <p className="vision-text-au">
                  To create a knowledge-sharing platform for ambitious, ethical, and future-ready energy Investors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Our Founders Section */}
      <section className="founders-section-au">
        <div className="container">
          <div className="row align-items-start align-items-center">
            <div className="col-lg-5 col-md-12">
              <div className="founders-intro-au">
                <h2 className="founders-title-au">Meet Our Founders</h2>
                <p className="founders-subtitle-au">
                  Meet the visionaries behind our community.
                </p>
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              <div className="founders-cards-wrapper-au">
                <div className="founder-card-au">
                  <div className="founder-photo-au">
                    <Image 
                      src={founderone} 
                      alt="Derrick May" 
                      fill
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                  <div className="founder-card-body-au">
                    <h4 className="founder-name-au">Derrick May</h4>
                    <p className="founder-title-au">
                      President / CEO, Optimum
                    </p>
                    <p className="founder-title-au">
                      Energy Partners
                    </p>
                    <p className="founder-role-au">
                      Co-founder, Invest in Energy
                    </p>
                    <a href="/founders/derrick-may" className="founder-link-au">
                      Learn More
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 12L12 4M12 4H6M12 4V10"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>

                <div className="founder-card-au">
                  <div className="founder-photo-au">
                    <Image 
                      src={foundertwo} 
                      alt="Sameer Somal, CFA" 
                      fill
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                  <div className="founder-card-body-au">
                    <h4 className="founder-name-au">Sameer Somal, CFA</h4>
                    <p className="founder-title-au">
                      CEO &amp; Founder, Blue Ocean
                    </p>
                    <p className="founder-title-au">
                      Global Technology
                    </p>
                    <p className="founder-role-au">
                      Co-founder, Invest in Energy
                    </p>
                    <a href="/founders/sameer-somal" className="founder-link-au">
                      Learn More
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 12L12 4M12 4H6M12 4V10"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section-au">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="values-title-au">Our Core Values</h2>
            </div>
          </div>
          <div className="row">
            {coreValues.map((value, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div className="value-card-au">
                  <div className="value-icon-wrapper-au">
                    {value.icon}
                  </div>
                  <h4 className="value-name-au">{value.title}</h4>
                  <p className="value-description-au">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise and Educational Approach Section */}
      <section className="expertise-section-au">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="expertise-box-au">
                <h3 className="expertise-title-au">The Expertise Behind Invest in Energy</h3>
                <p className="expertise-text-au">
                  Invest in Energy is a shared vision of industry leaders with expert knowledge in the oil, gas, finance, and education sectors. We came together to curate knowledge that spans investment analysis, policy, energy economics, and market research. Our collective aim is to simplify the complex and bring you the resources and tools you need to make confident, informed decisions in energy investment.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="education-box-au">
                <h3 className="education-title-au">Our Educational Approach</h3>
                <p className="education-text-au">
                  Invest in Energy exists to break the myth that investing in oil and gas is only for experts. By bringing knowledge and expert guidance to investors and learners alike, we are democratising the industry, making you stakeholders in how energy development happens with your current goals and future responsibility in mind. Through expert articles, interactive tools, and beginner-friendly guides, we are building a structured, informed, and confident community of investors.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="story-section-au">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <h2 className="story-title-au">Our Story</h2>
            </div>
            <div className="col-lg-7">
              <div className="story-content-au">
                <p className="story-text-au">
                  Purpose powered by expertise results in lasting value. With their years of experience in energy, market research, technology, and finance, our founding team noticed a critical gap. Within the complexity of the oil and gas industry, knowledge sharing was often limited.
                </p>
                <p className="story-text-au">
                 This meant the average individual or investor had limited access to knowledge about investing and industry trends. Educational resources, when available, were either biased, too technical, or locked behind paywalls, severely restricting the participation of interested investors.
                </p>
                <p className="story-text-au">
                  Invest in Energy is a commitment to bridge this gap by making energy investment knowledge accessible, understandable, and reliable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section-au">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="faq-title-au">Frequently Asked Questions</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-list-au">
                {faqs.map((faq, index) => (
                  <div key={index} className="faq-item-au">
                    <button 
                      className={`faq-question-au ${openFaq === index ? 'active-au' : ''}`}
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon-au">
                        {openFaq === index ? '−' : '+'}
                      </span>
                    </button>
                    {openFaq === index && (
                      <div className="faq-answer-au">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section-au">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2 className="cta-title-au">Ready to Join Our Community of Investors?</h2>
            </div>
            <div className="col-lg-6">
              <p className="cta-text-au">
                Fast track your learning journey and transform your investment approach with guidance from experts and peers.
              </p>
              <a href="/learn-investing" className="cta-button-au">Start Now</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

